export enum DefaultValueParameterEnum {
  CreateAnswerPickupTimeLimit = 10,
  FallbackRangeDate = 30
}
